export default "__VITE_ASSET__BSLFbZL___"